import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FiFile } from "react-icons/fi";
import {
  ViewDocumentAsOwnerDto,
  useGetBuyerSupplierInformationQuery,
  useListTextDocumentsForSourcingEventQuery,
} from "../../autogen/bff-api";
import { collectPublishedDocuments } from "../../common/components/communication/publishedDocuments";
import { CombinedDocuments } from "../../common/documents/CombinedDocuments";
import { DocumentsEmptyState } from "../../common/documents/DocumentsEmptyState";
import { SectionCard } from "../sourcing-events/portal/view-single/SectionCard";

export const DocumentsSection = ({ eventId, documents }: { eventId: string; documents: ViewDocumentAsOwnerDto[] }) => {
  const { t } = useTranslation();
  const { data: announcementsData, isLoading: isLoadingAnnouncements } = useGetBuyerSupplierInformationQuery({
    eventId,
  });
  const { data: textDocumentsData, isLoading: isLoadingTextDocuments } = useListTextDocumentsForSourcingEventQuery({
    eventId,
  });

  const announcementAttachments = useMemo(
    () =>
      collectPublishedDocuments(
        eventId,
        announcementsData?.supplierInformation ?? [],
        documents.map((d) => d.id),
      ),
    [eventId, announcementsData, documents],
  );
  const textDocuments = useMemo(() => textDocumentsData?.documents ?? [], [textDocumentsData]);

  const isLoading = isLoadingAnnouncements || isLoadingTextDocuments;

  return (
    <SectionCard
      icon={FiFile}
      title={t("Documents")}
      count={isLoading ? undefined : documents.length + announcementAttachments.length + textDocuments.length}
    >
      <CombinedDocuments
        uploadedDocuments={documents}
        textDocuments={textDocuments}
        announcementAttachments={announcementAttachments}
        isLoading={isLoading}
        emptyState={<DocumentsEmptyState />}
        isTagsColumnVisible
        isCreatedByColumnVisible={false}
        isCategoryColumnVisible
      />
    </SectionCard>
  );
};
